import { useQuery } from "@tanstack/react-query";
import axios from "axios";

/**
 * Trade medians (1M / 3M / 12M / all time, whole GBP) and the brand's PriceIQ
 * order margin for one listing — { currency, trade_median, brand, brand_order_margin }.
 * The review list sends it on every item (price_check_context); anywhere else it
 * is fetched once per listing and cached.
 */
export default function usePriceCheckContext(listing, { enabled = true } = {}) {
  const inline = listing?.price_check_context || null;
  const query = useQuery({
    queryKey: ["price-check-context", listing?.id],
    queryFn: async () => (await axios.get(`/api/listings/${listing.id}/price-check-context`, { metadata: { silent: true } })).data,
    enabled: enabled && !inline && !!listing?.id,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
  return inline || query.data || null;
}
